import { connect } from 'react-redux';
import Modal from './Modal';

export default connect(({ settings }) => ({
  settings,
}))(Modal);
